import React, { useState, useRef, useEffect } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import moment from 'moment'

export default function DateRangePickerInput(props) {
  const [range, setRange] = useState(undefined);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function onClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  function formatDate(date) {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  function formatRange(range) {
    if (!range || (!range.from && !range.to)) return '';
    if (range.from && range.to)
      return `${formatDate(range.from)} – ${formatDate(range.to)}`;
    if (range.from) return `${formatDate(range.from)} – ...`;
    if (range.to) return `... – ${formatDate(range.to)}`;
    return '';
  }

  function handleSelect(selectedRange) {
    setRange(selectedRange);
    if (selectedRange?.from && selectedRange?.to) {
      setOpen(false);
    }
    props.gridApi.setFilterModel({
        "invoiceDate": {
            "dateFrom": moment(selectedRange?.from).format('YYYY-MM-DD'),
            "dateTo": moment(selectedRange?.to).format('YYYY-MM-DD'),
            "type": "inRange",
            "filterType": "date"
        }
    });
  }


  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <input
        type="text"
        className='form-control'
        readOnly
        onClick={() => setOpen(true)}
        value={formatRange(range)}
        placeholder="Select date range"
      />
      {open && (
        <div
          style={{
            position: 'absolute',
            zIndex: 1000,
            background: 'white',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            marginTop: 4,
            right:0
          }}
        >
          <DayPicker
            mode="range"
            selected={range}
            onSelect={handleSelect}
            footer={
              range?.from && range?.to
                ? `You picked from ${formatDate(range.from)} to ${formatDate(range.to)}`
                : 'Please select the first day.'
            }
          />
        </div>
      )}
    </div>
  );
}
